import {Button, Divider, Row} from "antd";
import React from "react";
import {createSearchParams, generatePath, useNavigate, useSearchParams} from "react-router-dom";
import {StyledUserApplicationItem} from "./index.styles";
import dayjs from "dayjs";
import {IconApplicationsDate} from "../../../../../../assets";
import {ROUTE_PATH} from "../../../../../../constants";
import {useDispatch} from "react-redux";
import {fetchGetInfoAction} from "../../../../../../store/pages/admission/actions";
import {useTranslation} from "react-i18next";
import {encodeBase64} from "../../../../../../utils/encodeBase64";


interface IUserApplicationItems {
  number: number,
  title: string,
  status: string,
  date: string
}

export const UserApplicationItem = (props: IUserApplicationItems) => {
  const {number, title, status, date} = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation(["educationOrders", "rup"])
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParams = searchParams.get('tab')

  const handleClick = () => {
    if (status) {
      //@ts-ignore
      dispatch(dispatch(fetchGetInfoAction({education_order_id:number})))
      let path = {
        pathname: generatePath(ROUTE_PATH.ENTRANT_USER_APPLICATIONS_CURRENT, {id: `${encodeBase64(number)}`}),
        // @ts-ignore
        search: createSearchParams({
          tab: tabParams ? tabParams : 1
        }).toString(),
      }
      navigate(path)
    } else {
      let path = {
        pathname: generatePath(ROUTE_PATH.ENTRANT_ADMISSION),
        // @ts-ignore
        search: createSearchParams({
          education_order_id: encodeBase64(number),
          tab: tabParams ? tabParams : 1
        }).toString(),
      }
      navigate(path)
    }
  }

  const statusString = (status: string) => {
    switch (status) {
      case "2":
        return t("educationOrders:accepted")
      case "3":
        return t("educationOrders:rejected")
      case "5":
        return t("educationOrders:revoked")
      case "0":
        return t("educationOrders:sent")
    }
  }

  return (
    <StyledUserApplicationItem>
      <Row justify="space-between">
        <Row align="middle">
          <p className="number">№{number}</p>
          <p className="title">{title}</p>
        </Row>
        <Row align="middle">
          <p className="status">{status ? `${statusString(status)}` : t("educationOrders:draft")}</p>
          <Row align="middle" className="date"><IconApplicationsDate
            style={{marginRight: 6}}/>{dayjs(date).format("DD.MM.YYYY, HH:MM:ss")}</Row>
          <Divider type="vertical" style={{height: 64, marginRight: 24, marginLeft: 24}}/>
          <Button size="large" className="openApplication" onClick={handleClick}>{t("rup:tabs.view")}</Button>
          {/*<Button size="large" className="moreButton"><IconApplicationsMore /></Button>*/}
        </Row>
      </Row>
    </StyledUserApplicationItem>
  )
}